import { render, staticRenderFns } from "./SlackLinkUser.view.vue?vue&type=template&id=ef74928c&scoped=true&"
import script from "./SlackLinkUser.view.vue?vue&type=script&lang=js&"
export * from "./SlackLinkUser.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef74928c",
  null
  
)

export default component.exports